import React, { useState, useEffect } from 'react';
import  "../../Css/Modal.css";
import styles from "../../Css/ModalFilters.module.scss";
import {
    IonModal, IonCard, IonToolbar, IonTitle, IonButtons, IonButton, IonSegmentButton,
    IonContent, IonItem, IonLabel, IonRow, IonCol, IonIcon, IonSegment
} from '@ionic/react';
import { close, search, trash } from 'ionicons/icons';
import {getArticleGroups, getAreasByRestaurant} from '../../Services';
import CustomSelectorSearch from "../../../../General/Components/CustomSelectorSearch";

const ModalFilters = ({ open, fn, filter, physicTakeHeaderCode }) => {
    const [articleCodeText, setArticleCodeText] = useState('');
    const [articleNameText, setArticleNameText] = useState('');
    const [articleMovements, setArticleMovements] = useState(1);
    const [isOpenSearchArticle, setIsOpenSearchArticle] = useState(false);
    const [isOpenSearchAreas, setIsOpenSearchAreas] = useState(false);
    const [articleGroups, setArticleGroups] = useState([]);
    const [articleGroupsSelected, setArticleGroupsSelected] = useState([]);
    const [articleGroupsText, setArticleGroupsText] = useState('');
    const [areasByRestaurant, setAreasByRestaurant] = useState([]);
    const [areasByRestaurantSelected, setAreasByRestaurantSelected] = useState([]);
    const [areasByRestaurantText, setAreasByRestaurantText] = useState('');

    useEffect(() => {
        initialData();
	// eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initialData = () => {
		getGroups();
        getAreas();
    };

    function getGroups() {
        getArticleGroups(physicTakeHeaderCode).then((response) => {
            if(response.status){
                // sessionStorage.setItem('articleGroups', JSON.stringify(response.data));
                setArticleGroups(response.data);
            }
        });
    }

    function getAreas(){
        const areas = JSON.parse(sessionStorage.getItem('areasByRestaurant'));
		if(areas){
            setAreasByRestaurant(areas);
		}else {
			getAreasByRestaurant().then((response) => {
				if(response.status){
                    sessionStorage.setItem('areasByRestaurant', JSON.stringify(response.data));
                    setAreasByRestaurant(response.data);
				}
			});
		}
    }

    function openSearchArticle() {
        setIsOpenSearchArticle(!isOpenSearchArticle);
    }

    function openSearchAreas() {
        setIsOpenSearchAreas(!isOpenSearchAreas);
    }

    function confirmArticleGroup(response){
        setArticleGroupsSelected(response);
        setArticleGroupsText(response.map(item => item.description).join(", "));
        setIsOpenSearchArticle(!isOpenSearchArticle);
    }

    function confirmAreas(response){
        setAreasByRestaurantSelected(response);
        setAreasByRestaurantText(response.map(item => item.description).join(", "));
        setIsOpenSearchAreas(!isOpenSearchAreas);
    }

    const changeGroupArticles = (event) => {
        setArticleGroupsText(event.target.value);
    }

    const changeAreas= (event) => {
        setAreasByRestaurantText(event.target.value);
    }

    const changeArticleCodeText= (event) => {
        setArticleCodeText(event.target.value);
    }

    const changeArticleNameText = (event) => {
        setArticleNameText(event.target.value);
    }

    const changeArticleMovements = (type) => {
        setArticleMovements(type);
    }

    const clearFilters = () => {
        setArticleCodeText('');
        setArticleNameText('');
        setArticleGroupsText('');
        setArticleGroupsSelected([]);
        setAreasByRestaurantText('');
        setAreasByRestaurantSelected([]);
        setArticleMovements(1);
        filter({}, 0);
    }

    const filterElements = () => {
        const parameters = {
            codeArticle: articleCodeText,
            nameArticle: articleNameText,
            movementsArticle: articleMovements,
            groupArticle: articleGroupsSelected.map(item => item.articleGroup).join(","),
            areasArticle: areasByRestaurantSelected.map(item => item.description).join(",")
        };
        filter(parameters, 1);
    }

    return (
        <IonModal id="example-modal" isOpen={open} onDidDismiss={() => fn(false)}>
            <IonContent>
                <IonToolbar>
                    <IonTitle className={styles.tittle}>Filtros</IonTitle>
                    <IonButtons slot="end">
                        <IonButton color="light" onClick={() => fn(false)}>
                            <IonIcon icon={close} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <div className={styles.center}>
                    <IonCard className={styles.card}>
                        <IonRow>
                            <IonCol size="12" size-md="12">
                                <div className={styles.singleInput}>
                                    <input 
                                        type="text"
                                        className="input"
                                        id="articleCode"
                                        required
                                        value={articleCodeText}
                                        onChange={changeArticleCodeText}
                                    />
                                    <label htmlFor='articleCode'>Código Artículo</label>
                                </div>
                            </IonCol>
                            <IonCol size="12" size-md="12">
                                <div className={styles.singleInput}>
                                    <input
                                        type="text"
                                        className="input"
                                        id="articleName"
                                        required
                                        value={articleNameText}
                                        onChange={changeArticleNameText}
                                    />
                                    <label htmlFor='articleName'>Nombre Artículo </label>
                                </div>
                            </IonCol>
                            <IonCol size="12" size-md="12">
                                <div className={styles.singleInput}>
                                    <input 
                                        type="text"
                                        className="input"
                                        id="articleGroup"
                                        onClick={openSearchArticle}
                                        required
                                        value={articleGroupsText}
                                        onChange={changeGroupArticles}
                                    />
                                    <label htmlFor='articleGroup'>Grupos Artículos</label>
                                </div>
                            </IonCol>
                            {areasByRestaurant.length > 0 && (
                                <IonCol size="12" size-md="12">
                                    <div className={styles.singleInput}>
                                        <input 
                                            type="text"
                                            className="input"
                                            id="areas"
                                            onClick={openSearchAreas}
                                            required
                                            value={areasByRestaurantText}
                                            onChange={changeAreas}
                                        />
                                        <label htmlFor='areas'>Áreas</label>
                                    </div>
                                </IonCol>
                            )}
                            <IonCol size="12" size-md="12">
                                <IonLabel className={styles.textArticles}><b>Artículos</b></IonLabel>
                            </IonCol>
                            <IonCol size="12" size-md="12">
                                <IonItem>
                                    
                                    <br/>
                                    <IonSegment value={articleMovements}
                                        className={styles.articleMovement}
                                        mode="ios"
                                    >
                                        <IonSegmentButton value="2" onClick={() => changeArticleMovements(2)}>
                                            <IonLabel>Todos</IonLabel>
                                        </IonSegmentButton>
                                        <IonSegmentButton value="0" onClick={() => changeArticleMovements(0)}>
                                            <IonLabel>Sin Movimientos</IonLabel>
                                        </IonSegmentButton>   
                                        <IonSegmentButton value="1" onClick={() => changeArticleMovements(1)}>
                                            <IonLabel>Con Movimientos</IonLabel>
                                        </IonSegmentButton>
                                    </IonSegment>
                                </IonItem>
                            </IonCol>
                            <IonCol size="6" size-md="6">
                                <IonButton type="submit" expand="block" size="small" onClick={clearFilters}>
                                    <IonIcon icon={trash} />
                                </IonButton>
                            </IonCol>
                            <IonCol size="6" size-md="6">
                                <IonButton type="submit" expand="block" size="small" onClick={filterElements}>
                                    <IonIcon icon={search} />
                                </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonCard>
                </div>
            </IonContent>
            <CustomSelectorSearch 
                open={isOpenSearchArticle}
                tittle={"Grupo de Artículos"}
                onSelectionCancel={openSearchArticle}
                onSelectionConfirm={confirmArticleGroup}
                data={articleGroups}
                identifier={'articleGroup'}
                description={'description'}
                multiple={true}
                returnObject={true}
                selectedItems={articleGroupsSelected}
            />
            <CustomSelectorSearch 
                open={isOpenSearchAreas}
                tittle={"Listado de Áreas"}
                onSelectionCancel={openSearchAreas}
                onSelectionConfirm={confirmAreas}
                data={areasByRestaurant}
                identifier={'areaCode'}
                description={'description'}
                multiple={true}
                returnObject={true}
                selectedItems={areasByRestaurantSelected}
            />
        </IonModal>
    );
};

export default ModalFilters;
